export default __webpack_public_path__ + "static/media/back_arrow_icon.c8a2b5c3.svg";